import { patchState, WritableStateSource } from '@ngrx/signals';

import { NavigationState } from './navigation.store';

export const navigationReductionMethodsFactory = (store: WritableStateSource<NavigationState>) => ({
  toggleVisibility(): void {
    patchState(store, (state) => ({ hiddenOnHandset: !state.hiddenOnHandset }));
  },
});
